// ======================================================================
// File Name       : ReportAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { commonCallApi } from '../utils/ApiUtils';
import * as ActionTypes from '../constants/actionTypes/report';
import * as reportRequests from './httpRequests/report';
import * as reportActionCreators from './actionCreators/report';
import { SELECT_TARGET_DATA, MODE, DEFAULT_DATE_TO_TEXT, DEFAULT_DATE_FROM_TEXT, DEFAULT_DATE_FORMAT_SERVER } from '../constants/index';
import { MIN_MAX_DATE_TXT } from '../utils/index';

export function fetchReport(param) {
  return dispatch =>
    reportRequests.postReportGetList(param).then((apiRes) => {
      dispatch(reportActionCreators.receiveReportList(apiRes));
      return apiRes;
    });
}

export function updateReport(payload) {
  return dispatch => dispatch(reportActionCreators.updateReport(payload));
}

export function initDataForReportRegisterDialog() {
  return dispatch => dispatch(reportActionCreators.initDataForReportRegisterDialog());
}

export function saveReport(itemName, itemSecernId) {
  return (dispatch, getState) => {
    const { editMode, editingReport: { reportDeadline, reportReturnPlanDate } } = getState().report;

    const reportInfo = {};
    reportInfo.reportDeadline = '';
    if (reportDeadline && reportDeadline !== DEFAULT_DATE_TO_TEXT) {
      reportInfo.reportDeadline = moment(reportDeadline).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER);
    }
    reportInfo.reportReturnPlanDate = '';
    if (reportReturnPlanDate && reportReturnPlanDate !== DEFAULT_DATE_FROM_TEXT) {
      reportInfo.reportReturnPlanDate = moment(reportReturnPlanDate).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER);
    }
    reportInfo.itemSecernId = itemSecernId;
    reportInfo.reportName = itemName;
    return reportRequests.postReportEdit({
      editType: editMode,
      reportInfo,
    });
  };
}
